export const GET_DICTIONARY_PERMISSIONS = Symbol('GET_DICTIONARY_PERMISSIONS');
export const GET_DICTIONARY_PERMISSIONS_REQUEST = Symbol('GET_DICTIONARY_PERMISSIONS_REQUEST');
export const GET_DICTIONARY_PERMISSIONS_SUCCESS = Symbol('GET_DICTIONARY_PERMISSIONS_SUCCESS');
export const GET_DICTIONARY_PERMISSIONS_ERROR = Symbol('GET_DICTIONARY_PERMISSIONS_ERROR');

